import * as yup from 'yup';
export const timelineActivitySchema = yup.object().camelCase().required().shape({
    id: yup.string().required(),
    activityType: yup.string().required(),
    userName: yup.string().required(),
    date: yup.date().required(),
    activityTitle: yup.string().required(),
    previousState: yup.string().nullable(),
    newState: yup.string().nullable(),
    program: yup.string().nullable(),
    taskName: yup.string().nullable(),
    taskAssignedTo: yup.string().nullable(),
    taskCompletedBy: yup.string().nullable(),
    taskDueDate: yup.string().nullable(),
    notes: yup.string().nullable(),
    reportId: yup.string().nullable(),
    reviewType: yup.string().nullable(),
    reviewTimeSpent: yup.string().nullable(),
    reviewDidTalk: yup.boolean().nullable()
});
